import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=325c6184&scoped=true&"
import script from "./Pesquisa.vue?vue&type=script&lang=js&"
export * from "./Pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&id=325c6184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c6184",
  null
  
)

export default component.exports